import * as actions from 'actions';
import pagingMaker from 'reducersMakers/pagingMaker';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('queryString',
  pagingMaker({
    fetchType: actions.MAGAZINE_ARTICLES_FETCH,
    fetchSuccessType: actions.MAGAZINE_ARTICLES_FETCH_SUCCESS,
    fetchErrorType: actions.MAGAZINE_ARTICLES_FETCH_ERROR,
    possiblePageUpdateType: actions.MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE
  })
);



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/paging/magazineArticles/byQuery/reducer.js
 **/